const notificationElement = document.getElementById("notification-banner")

if (notificationElement) {
	const bannerDismiss = document.getElementById("banner-dismiss")
	const bannerID = notificationElement.getAttribute("data-banner-id")

	if (bannerID) {
		bannerDismiss.addEventListener("click", function (e) {
			e.preventDefault()

			// We want to add this cookie so that we can look to see if it exists and matches the bannerID on the frontend using a plugin.
			document.cookie = "notification-banner=" + bannerID

			// If the banner has been closed we want to hide it on the initial screen
			notificationElement.classList.add("hidden")
		})
	}
}
